import React from "react";
import RenderRoutes from './routes'
function App() {
  return (
    <RenderRoutes />
  )
}

export default App;
